export default "//yastatic.net/s3/distribution/pythia/frontend/_/710d07ab5652067b0726dbaffdc1eb93.png";